import { StubbornAttribute } from "../../../../../../../../business/StubbornAttributeMapping";

export const makeCustomAttributeGroup = (label: string, name: string, attributes: Set<StubbornAttribute>) => ({
  label,
  name,
  priority: 1,
  attributes,
});
